export default "__VITE_ASSET__CR75i5oF__"